export const constListScroll = { scrollToFirstRowOnChange: true, y: 'calc(100vh - 350px)', x: '100%' };
export const modelDeletePageTableScroll = { scrollToFirstRowOnChange: true, y: 'calc(40vh)', x: '100%' }

export const constPageSizeOptions = ['10', '30', '50', '100'];
